/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    NumberOfDevicesPerTagItem,
    NumberOfDevicesPerTagItemFromJSON,
    NumberOfDevicesPerTagItemToJSON,
    TagsResponse,
    TagsResponseFromJSON,
    TagsResponseToJSON,
} from '../models';

export interface ReadTagsAvailableToSetToDeviceRequest {
    deviceId: string;
}

export interface ReadTagsAvailableToSetToGroupRequest {
    groupId?: string;
    deviceTypeId?: string;
}

/**
 * 
 */
export class TagsApi extends runtime.BaseAPI {

    /**
     * Read number of devices for each tag
     */
    async readNumberOfDevicesForEachTagRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<NumberOfDevicesPerTagItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tags/devices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NumberOfDevicesPerTagItemFromJSON));
    }

    /**
     * Read number of devices for each tag
     */
    async readNumberOfDevicesForEachTag(initOverrides?: RequestInit): Promise<Array<NumberOfDevicesPerTagItem>> {
        const response = await this.readNumberOfDevicesForEachTagRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read all tags available for setting to device
     */
    async readTagsAvailableToSetToDeviceRaw(requestParameters: ReadTagsAvailableToSetToDeviceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Set<TagsResponse>>> {
        if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
            throw new runtime.RequiredError('deviceId','Required parameter requestParameters.deviceId was null or undefined when calling readTagsAvailableToSetToDevice.');
        }

        const queryParameters: any = {};

        if (requestParameters.deviceId !== undefined) {
            queryParameters['deviceId'] = requestParameters.deviceId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => new Set(jsonValue.map(TagsResponseFromJSON)));
    }

    /**
     * Read all tags available for setting to device
     */
    async readTagsAvailableToSetToDevice(requestParameters: ReadTagsAvailableToSetToDeviceRequest, initOverrides?: RequestInit): Promise<Set<TagsResponse>> {
        const response = await this.readTagsAvailableToSetToDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read all tags available for setting to group
     */
    async readTagsAvailableToSetToGroupRaw(requestParameters: ReadTagsAvailableToSetToGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Set<TagsResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.groupId !== undefined) {
            queryParameters['groupId'] = requestParameters.groupId;
        }

        if (requestParameters.deviceTypeId !== undefined) {
            queryParameters['deviceTypeId'] = requestParameters.deviceTypeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tags/groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => new Set(jsonValue.map(TagsResponseFromJSON)));
    }

    /**
     * Read all tags available for setting to group
     */
    async readTagsAvailableToSetToGroup(requestParameters: ReadTagsAvailableToSetToGroupRequest = {}, initOverrides?: RequestInit): Promise<Set<TagsResponse>> {
        const response = await this.readTagsAvailableToSetToGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
